import { connectedStore } from '../../store';
import selectors from '../selectors';

const getExtension = (extensionSlug) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getExtension(state, extensionSlug);
};

export default getExtension;
